import { createEntityAdapter, EntityAdapter, EntityState } from "@ngrx/entity";
import { createReducer, on } from "@ngrx/store";
import { IPerson } from "src/app/interfaces";
import { PersonActions, PersonAPIActions } from "./actions";

export interface PersonState extends EntityState<IPerson> {
  error: string;
  loaded: boolean;
}

export const adapter: EntityAdapter<IPerson> = createEntityAdapter<IPerson>();

const {
  /* eslint-disable @typescript-eslint/no-unused-vars */
  selectIds,
  selectEntities,
  selectAll,
  selectTotal
  /* eslint-enable @typescript-eslint/no-unused-vars */
} = adapter.getSelectors();

export const selectPersonEntities = selectEntities;
export const selectAllPersons = selectAll;

const initialState: PersonState = adapter.getInitialState({
  // additional entity state properties
  error: "",
  loaded: false
});

export const personReducer = createReducer(
  initialState,
  on(PersonActions.addPerson, (state, action) =>
    adapter.addOne(action.person, state)
  ),
  on(
    PersonActions.upsertPerson,
    PersonAPIActions.loadPersonByLoginSuccess,
    (state, action) => adapter.upsertOne(action.person, state)
  ),
  on(PersonActions.addPersons, (state, action) =>
    adapter.addMany(action.persons, state)
  ),
  on(PersonActions.upsertPersons, (state, action) =>
    adapter.upsertMany(action.persons, state)
  ),
  on(PersonActions.updatePerson, (state, action) =>
    adapter.updateOne(action.person, state)
  ),
  on(PersonActions.updatePersons, (state, action) =>
    adapter.updateMany(action.persons, state)
  ),
  on(PersonActions.deletePerson, (state, action) =>
    adapter.removeOne(action.id, state)
  ),
  on(PersonActions.deletePersons, (state, action) =>
    adapter.removeMany(action.ids, state)
  ),
  on(PersonActions.clearPersons, (state) => adapter.removeAll(state)),
  on(
    PersonAPIActions.loadPersonByLoginFailure,
    (state, action): PersonState => {
      return {
        ...adapter.removeAll(state),
        error: action.error,
        loaded: false
      };
    }
  )
);
